// extracted by mini-css-extract-plugin
export default {"details-benefit":"BenefitInfo_details-benefit__zMwW9","benefit-code":"BenefitInfo_benefit-code__KYFd6","step":"BenefitInfo_step__YUdfv","visibility":"BenefitInfo_visibility__kRa1-"};